var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2242_729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2242_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6935 1.83739C15.8182 0.768394 14.1835 0.768398 13.3084 1.83739L12.0685 3.3517C11.9836 3.45549 11.8418 3.49348 11.7163 3.44608L9.88546 2.75454C8.59302 2.26638 7.17728 3.08374 6.95382 4.44713L6.63728 6.37847C6.61558 6.51084 6.51182 6.6146 6.37943 6.6363L4.44811 6.95284C3.08473 7.1763 2.26734 8.59203 2.75552 9.88448L3.44706 11.7153C3.49446 11.8408 3.45647 11.9826 3.35268 12.0676L1.83837 13.3073C0.769371 14.1826 0.769373 15.8173 1.83837 16.6926L3.35268 17.9323C3.45647 18.0173 3.49446 18.1591 3.44706 18.2846L2.75552 20.1155C2.26736 21.4078 3.08472 22.8236 4.44811 23.0471L6.37943 23.3636C6.51182 23.3853 6.61558 23.4891 6.63728 23.6215L6.95382 25.5527C7.17728 26.9161 8.59301 27.7335 9.88546 27.2453L11.7163 26.5538C11.8418 26.5065 11.9836 26.5443 12.0685 26.6482L13.3084 28.1625C14.1835 29.2315 15.8182 29.2315 16.6935 28.1625L17.9332 26.6482C18.0182 26.5443 18.16 26.5065 18.2855 26.5538L20.1164 27.2453C21.4089 27.7335 22.8246 26.9161 23.048 25.5527L23.3646 23.6215C23.3862 23.4891 23.49 23.3853 23.6224 23.3636L25.5537 23.0471C26.9171 22.8236 27.7345 21.4078 27.2464 20.1155L26.5547 18.2846C26.5074 18.1591 26.5454 18.0173 26.6491 17.9323L28.1635 16.6926C29.2325 15.8173 29.2325 14.1826 28.1635 13.3073L26.6491 12.0676C26.5454 11.9826 26.5074 11.8408 26.5547 11.7153L27.2464 9.88448C27.7345 8.59203 26.9171 7.1763 25.5537 6.95284L23.6224 6.6363C23.49 6.6146 23.3862 6.51084 23.3646 6.37847L23.048 4.44713C22.8246 3.08375 21.4089 2.26637 20.1164 2.75454L18.2855 3.44608C18.16 3.49348 18.0182 3.45549 17.9332 3.3517L16.6935 1.83739Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5384 9.96208C22.9045 10.3282 22.9045 10.9218 22.5384 11.2879L13.7884 20.0379C13.6126 20.2138 13.3741 20.3125 13.1255 20.3125C12.8769 20.3125 12.6384 20.2138 12.4626 20.0379L7.46257 15.0379C7.09646 14.6717 7.09646 14.0782 7.46257 13.7121C7.82869 13.346 8.42229 13.346 8.7884 13.7121L13.1255 18.0491L21.2126 9.96208C21.5787 9.59597 22.1722 9.59597 22.5384 9.96208Z",
    fill: "#ECEFF1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.dc6c6249fb4d72b1294008e83b92ac98.svg";
export { ForwardRef as ReactComponent };